import randomize from "@/mixins/Customizer/Randomize";
import selectSwatch from "@/mixins/Customizer/SelectSwatch";
import { resolveImageLibraryLabel } from "@/utils/imageLibraryLabel";

export const numGroupsToInit = 4;
export const DEFAULT_TAB = 'solids';

export default {
  data() {
    return {
      initGroup: 0,
      defaultComponentsTab: null,
      lastComponentSwatchApplied: null,
      previousComponent: '',
      nextComponent: '',
      primaryTabs: {},
      subgroups: {},
      active_tab: "",
      disableUGCTab: false,
      personalizationAllowed: true,
      order: 0,
      previousActiveTab: "",
      previousSelectedComponent: "",
      existSwatchPreviousTab: false,
      propertiesInit: []
    };
  },
  mixins: [selectSwatch,randomize],
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    availableSwatches() {
      return this.$store.state.utils.availableSwatches;
    },
    getGroupTabs() {
      return this.$store.state.swatches.groupTabs;
    },
    componentsWithGraphicsSupport() {
      return this.$store.getters["utils/componentsWithGraphicsSupport"];
    },
    activeSubComponent() {
      if (this.isApparel) {
        return this.standardNavigation.activeSubComponent;
      }
      return null
    },
    getTabsSwatches() {
      return this.$store.state.swatches.tabsSwatches[this.activeComponent];
    },
    selectedSwatches() {
      return this.$store.state.swatches.selectedSwatches;
    },
    isUGC() {
      return this.$store.getters['ugc/getUGCEnabledComponents'].includes(this.activeComponent);
    },
    isImageLibrary() {
      return this.$store.getters['ugc/getLibraryEnabledComponents'].includes(this.activeComponent);
    },
    isApparelUGC() {
      const subComponentName = this.activeSubComponent;
      if (!subComponentName) return false;
      const activeComponent = this.standardNavigation.activeComponent;
      const gdmIndex = this.$store.state.gdm.data.map(item => item.component3D)
      .indexOf(activeComponent);
      const gdmComponent = this.$store.state.gdm.data[gdmIndex].component.find(item => item.id === subComponentName);
      if (!gdmComponent) return false;
      return gdmComponent.ugc_enable;
    },
    legacyNavigation() {
      return this.$store.state.legacyNavigation;
    },
    standardNavigation() {
      return this.$store.state.standardNavigation;
    },
    apparelGdmParams() {
      if (!this.activeSubComponent) return false;
      const componentIndex = this.$store.state.gdm.config[0]?.component.map(item => item.id)
      .indexOf(this.activeSubComponent);
      return this.$store.state.gdm.config[0]?.component[componentIndex]
    },
    ugcUpcharge() {
      const upchargePrice = `ugcUpcharge-${this.pdm.sku}`;
      return this.isUGC || (this.isApparel && this.isApparelUGC)
        ? this.translations[upchargePrice] + " - "
        : "";
    },
    personalizationComponent(){
      return this.$store.getters["personalization/getPrimaryComponentName"];
    },
    isPersonalization() {
      return !!(
        this.personalizationComponent.length
        && (
          this.pdm.components[this.personalizationComponent]?.personalization_data?.[0]?.enabled === true
          || this.pdm.components[this.personalizationComponent]?.personalization_data?.[0]?.enabled === 'true'
        )
      );
    },
    getAvailableTabs() {
      return this.$store.state.swatches.availableTabs;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    defaultRecipe() {
      return this.$store.state.recipe.defaultRecipe;
    },
    exclusiveSwatches() {
      if(!this.$store.state.swatches.exclusiveSwatches) {
        return [];
      }
      return this.$store.state.swatches.exclusiveSwatches[this.activeComponent];
    },
    hasModelUgc() {
      return this.$store.getters['ugc/getUGCEnabledComponents'].length > 0;
    },
    swatchesRelation() {
      return this.$store.state.swatches.swatchesRelation;
    },
    ugcTooltipData() {
      const ugcPriceToolTip = this.pdm.ugcPriceToolTip;
      const data = {
        trigger: ugcPriceToolTip ? 'click hover' : 'manual',
        content:  ugcPriceToolTip || '',
        delay: { show: 500 }
      };
      if (!ugcPriceToolTip) data.show = false;
      return data;
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    enablePersonalization() {
      return this.$store.getters["utils/isPersonalizationEnabled"];;
    },
    rayTracerDisabled() {
      return this.$store.state.utils.trayDisabled.swatches || this.$store.state.utils.trayDisabled.geostates;
    },
    ugcBlockedPalettes() {
      return this.$store.state.ugc.ugcBlockedPalettes;
    },
    ugcBlockedTab() {
      let ugcBlockedTab = null;

      if (this.ugcBlockedPalettes[this.activeComponent]) {
        const swatchId = this.recipe_v2.components[this.activeComponent].swatch_id;
        ugcBlockedTab = this.$store.getters['swatches/getPaletteDataBySwatch'](swatchId) || true;
      }

      return ugcBlockedTab;
    },
    /*
     * @computed - uniqueSwatchesAndPaletteBlockedTabs
     * Array with tab IDs of swatches that have unique_swatch attribute as true
     * OR with tab IDs of palettes with palette_lock attribute as 1
     */
    uniqueSwatchesAndPaletteBlockedTabs() {
      const swatchesListByComponent = this.$store.state.swatches.swatchesListByComponent[this.activeComponent];
      const uniqueSwatchesTabs = this.$store.getters['swatches/uniqueSwatches'].reduce((whole, { id }) => {
        const palette = this.$store.state.swatches.palettes.find(({ palette_id }) => (
          palette_id === parseInt(this.$store.getters['swatches/getPaletteDataBySwatch'](id, 'id'))
        ));

        if (swatchesListByComponent && swatchesListByComponent.includes(id) && palette && !whole.includes(palette.tab_id)) {
          whole.push(palette.tab_id);
        }

        return whole;
      }, []);

      return uniqueSwatchesTabs.length ? uniqueSwatchesTabs
        : this.$store.getters['swatches/lockedPalettes'].reduce((whole, { tab }) => {
        if (tab && !whole.includes(tab)) {
          whole.push(tab);
        }
        return whole;
      }, []);
    },
    /*
     * @computed - defaultUniqueSwatchesPaletteBlockedPerComponent
     * Default tab id if locked palettes or unique swatches exist (will be the first tab of the visible ones)
     */
    defaultUniqueSwatchesPaletteBlockedPerComponent() {
      return this.uniqueSwatchesAndPaletteBlockedTabs.find(lockedTab => (
        this.getTabsSwatches && this.getTabsSwatches[lockedTab] && !!this.getTabsSwatches[lockedTab].total
      ));
    },
    swatchesInPalettes() {
      return this.$store.state.swatches.swatchesInPalettes;
    },
    queryUgcImage() {
      return this.$store.state.utils.queryParams.ugcImage;
    },
    showPreloader() {
      return this.$store.state.preloader.showPreloader;
    },
    isSplashModalOpen() {
      return this.$store.state.utils.isSplashModalOpen;
    },
    isColorPickerOpen() {
      return this.$store.state.pickYourOwnColor.isOpen;
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
    shouldShowTabs() {
      return (
        !this.isSplashModalOpen
        && !(
          this.active_tab === "yourcolors"
          && this.isColorPickerOpen
          && this.isMobile
        )
      )
    },
    isRandomizeEnabled() {
      return this.pdm && !this.configuration.randomize?.turn_off_all_models && this.configuration.randomize?.models_enabled.includes(this.pdm.sku);
    },
    tempData() {
      return this.$store.state.ugc.tempData;
    }
  },
  watch: {
    availableSwatches() {
      if(!this.propertiesInit.includes("availableSwatches")){
        this.initGroup++;
        this.propertiesInit.push("availableSwatches")
      }
    },
    pdm(newValue) {
      if(!this.propertiesInit.includes("pdm")){
        this.initGroup++;
        this.propertiesInit.push("pdm")
      }
      this.setDefaultComponentsTab();
      if (newValue) {
        this.lastComponentSwatchApplied = this.pdm?.default_component;
        /**Reload all the tabs when is transfer design and it is getting the palettes fron the configuration file **/
        if (this.configuration?.enableTransferDesignConfigPalettes && this.$store.state.utils.isDesignTransfering && this.activeComponent &&
           !this.isApparelEnabled ) {
          this.initGroup = 4;
        }
      }
    },
    recipe_v2() {
      if (!this.isSplashModalOpen && !this.propertiesInit.includes("recipe")) {
        this.initGroup++;
        this.propertiesInit.push("recipe")
        this.loadedComponentSelectedTab();
      }
    },
    activeComponent(newValue, oldValue) {
      if (newValue !== oldValue) {
        // Just for the first time, when the customizer loads
        if (oldValue == '') {
          oldValue = this.pdm?.default_component;
        }
        const { components: recipeComponents } = this.recipe_v2;
        const { components: defaultComponents } = this.defaultRecipe;

        let { recipeSwatchId: oldRecipeSwatchId, defaultSwatchId: oldDefaultSwatchId } = this.$recipe.getSwatchIdsInRecipes({
          recipeComponents,
          defaultComponents,
          component: oldValue
        });
        if (oldRecipeSwatchId !== oldDefaultSwatchId) {
          this.lastComponentSwatchApplied = oldValue;
        }
        this.previousComponent = this.lastComponentSwatchApplied;

        if (this.configuration.enableNewHistoryTabLogic && !this.existSwatchPreviousTab) {
          this.previousComponent =  oldValue;
        }
        this.nextComponent = newValue;
      }
      if(!this.propertiesInit.includes("component")){
        this.initGroup++;
        this.propertiesInit.push("component")
      }
      if (this.$store.state.swatches.groups && this.initGroup >= numGroupsToInit) {
        this.$eventBus.$emit("blockRelationSwatches");
        if (this.$store.state.swatches.swatchesByComponent[this.activeComponent] && this.$store.state.swatches.palettesByComponent[this.activeComponent]) {
          this.loadedComponentSelectedTab();
        }
        this.setHistoryTab();
        if (this.$store.state.utils.isDesignTransfering && this.activeComponent &&
          String(this.activeComponent).search('/') !== -1) {
          this.initGroup = 4;
        }
      }
    },
    personalizationAllowed(newVal) {
      if(newVal !== undefined) {
        this.$eventBus.$emit("personalization-is-disabled", !newVal);
      }
    },
    initGroup(newVal) {
      if (newVal === numGroupsToInit) {
        this.initGroups();
      }
    },
    showPreloader() {
      const addYourOwn = this.getGroupTabs['add-your-own'];
      if (!this.showPreloader && addYourOwn) {
        const isGCC = this.$store.getters["utils/isGCC"] && this.recipe_v2;
        const hasUgcImageParam = !!this.queryUgcImage;

        // because ImageUpload component is only created when add-your-own tab is selected
        // it checks if current design is GCC (via submission_id or recipe) or if it
        // has ugcImage, then change the current tab to trigger the dialog from UploadImage
        if (isGCC || hasUgcImageParam) {
          this.changeTab(addYourOwn);
        }
      }
    }
  },
  methods:{
    getTabLabel(tab) {
      if (tab.name !== "image-gallery") return tab.display_name;

      return resolveImageLibraryLabel(this.translations, tab.display_name);
    },
    updateDefaultComponentsTabByRecipe() {
      const { components: recipeComponents } = this.recipe_v2;
      if (!recipeComponents || !this.defaultComponentsTab) {
        return
      }
      for (let subComponent in recipeComponents[this.activeComponent]?.sub_components){
        if (!this.defaultComponentsTab[`${this.activeComponent}/${subComponent}`]) {
          this.defaultComponentsTab[`${this.activeComponent}/${subComponent}`] = DEFAULT_TAB;
        }
      }
    },
    setDefaultComponentsTab() {
      const { components: recipeComponents } = this.recipe_v2;
      const { components: defaultComponents } = this.defaultRecipe;
      if (!recipeComponents || !defaultComponents) {
        return
      }
      let { components: componentsPdm } = this.pdm;
      this.defaultComponentsTab = {};
      const recipeComponentList = Object.keys(recipeComponents);
      recipeComponentList.forEach((component) => {
        if (this.isApparel) {
          this.defaultComponentsTab[component] = componentsPdm[component]?.default_tab || DEFAULT_TAB;
          if (recipeComponents[component]?.sub_components) {
            for (let subComponent in recipeComponents[component]?.sub_components){
              this.defaultComponentsTab[`${component}/${subComponent}`] = DEFAULT_TAB;
            }
          }
        } else {
          if (
              (this.$store.state.utils.queryParams.recipe ||
              this.$store.state.finishMyDesign.isLoadingFinishMyDesign ||
              this.$store.state.utils.isRandomizeApplied)
            ) {
            if (this.checkForUGCComponent(component) && !this.isUGCFromSwatch(recipeComponents[component].swatch_id)) {
              this.defaultComponentsTab[component] = 'add-your-own';
            } else if (recipeComponents[component]?.swatch_id != defaultComponents[component]?.swatch_id) {
              const swatchObj = this.$store.getters["swatches/returnSwatchObj"]({ swatchId: recipeComponents[component]?.swatch_id });
              const group = this.$store.getters["swatches/returnSwatchGroupName"]({ swatch:  swatchObj });
              this.defaultComponentsTab[component] = group;
            } else {
              this.defaultComponentsTab[component] = componentsPdm[component]?.default_tab || DEFAULT_TAB;
            }
          } else {
            this.defaultComponentsTab[component] = componentsPdm[component]?.default_tab || DEFAULT_TAB;
          }
        }
      });
    },
    loadedComponentSelectedTab() {
      let activeTab;
      if (this.configuration.enableNewHistoryTabLogic) {
        if (!this.defaultComponentsTab) {
          this.setDefaultComponentsTab();
        }
        // This is mainly for apparel, to add the subcomponents
        this.updateDefaultComponentsTabByRecipe();

        if (this.previousComponent && this.nextComponent) {
          activeTab = this.getTabSelectedByComponent(this.previousComponent, this.nextComponent);
        }
      } else {
        let swatchDefault;
        if (!this.activeComponent.includes("/")) {
          swatchDefault = this.recipe_v2?.components?.[this.activeComponent]?.swatch_id ?? 0;
        } else {
          const component = this.activeComponent.split("/");
          swatchDefault = this.recipe_v2?.components?.[component[0]]?.sub_components?.[component[1]]?.swatch_id ?? 11021;
        }
        let prevselectedTabs = this.$store.state.swatches.selectedTabs[this.activeComponent];
        let ugcTempRecipe = this.tempData.features[this.tempData.activeUGCIndex].recipe;
        let historyTabs = this.$store.state.swatches.historySelectedTabs;
        let selectedSwatch = (this.selectedSwatches[this.activeComponent] && !this.selectedSwatches[this.activeComponent].default)
          ? this.selectedSwatches[this.activeComponent] : false;

        const previousComponent = this.configuration.enableFlyOutMenu ?
          this.standardNavigation.previousComponent : this.legacyNavigation.previousComponent;
        const lastComponentSwatchApplied = this.configuration.enableFlyOutMenu ?
          this.standardNavigation.lastComponentSwatchApplied :
          this.legacyNavigation.lastComponentSwatchApplied;
        const swatchObject = this.$store.getters['swatches/returnSwatchObj']({ swatchId: swatchDefault });
        let lastUgcSwatchGroup = false;
        let lastComponentSelectedTab;
        const isPrecreated = this.$store.state.utils.queryParams.recipe || false;
        let isAddYourOwn = this.checkForAddYourOwn(previousComponent, selectedSwatch, isPrecreated);
        let isAddYourOwnSubComponent = this.isApparel && this.$store.state.swatches.selectedTabs[this.activeComponent] === 'add-your-own' ? true : false;
        if (lastComponentSwatchApplied && this.configuration.enableAutoSelect) {
          lastComponentSelectedTab = this.$store.state.swatches.selectedTabs[lastComponentSwatchApplied];
          lastUgcSwatchGroup = this.checkforUGCSwatchGroup(lastComponentSwatchApplied);
        }

        const activeUGCFeature = this.$recipe.getUGCFeatureType(this.activeComponent);
        if (activeUGCFeature && (this.checkForUGCComponent(this.activeComponent) || ugcTempRecipe[this.activeComponent]) || isAddYourOwn || isAddYourOwnSubComponent) {
          activeTab = activeUGCFeature === "imageLibrary" ? "image-gallery" : "add-your-own";
        } else if (this.componentSwatchIsDefault() && historyTabs.length > 0) {
          // Select previously active; tab if component swatch and recipe are default
          let component = historyTabs[historyTabs.length - 1];
          let historyComponent = (this.selectedSwatches[component] && !this.selectedSwatches[component].default)
            ? this.selectedSwatches[component] : false;
          if (historyComponent && !this.isHideTab(historyComponent.group)) {
            activeTab = historyComponent.group;
          } else {
            activeTab = this.selectedTab(swatchDefault);
          }
        } else if (prevselectedTabs && !this.isHideTab(prevselectedTabs)) {
          // Select current's component last tab if it exists and isn't disabled
          activeTab = prevselectedTabs;
        } else if (selectedSwatch && selectedSwatch.swatchId && this.getAvailableTabs.includes(selectedSwatch.group)) {
          // Select swatch already selected
          activeTab = selectedSwatch.group;
        } else {
          // Select current component swatch tab
          activeTab = this.selectedTab(swatchDefault);
        }
        // When the swatch has palette only and the palette is loaded the palette tab
        // must be selected. Otherwise solids is set as fallback
        if (swatchObject && swatchObject.palette_only === true && this.swatchesInPalettes.includes(Number(swatchDefault))) {
          activeTab = this.$store.getters['swatches/getPaletteDataBySwatch'](swatchDefault) || DEFAULT_TAB;
        }
        // If exists ugcBlockedTab and ugcBlockedTab is a known tab id, then force it to be the active one
        if (!!this.ugcBlockedTab && this.ugcBlockedTab !== true) {
          activeTab = this.ugcBlockedTab;
        // If exist unique_swatch or palette_lock AND there is a default tab
        } else if (this.uniqueSwatchesAndPaletteBlockedTabs.length && !!this.defaultUniqueSwatchesPaletteBlockedPerComponent) {
          const setPerBlockedPalette = !this.uniqueSwatchesAndPaletteBlockedTabs.filter(lockedTab => lockedTab === activeTab).length;

          // If activeTab is not part of tabs to be shown by unique_swatch or palette_lock, then force default locked tab to be the active one
          if (setPerBlockedPalette && this.defaultUniqueSwatchesPaletteBlockedPerComponent !== activeTab) {
            activeTab = this.defaultUniqueSwatchesPaletteBlockedPerComponent;
          }
        }

        // If the tabs is not present and it the swatch is in a palette with palette_only equal true
        // That palette should be selected by default.
        if (this.swatchesInPalettes.includes(Number(swatchDefault))) {
          const paletteId = this.$store.getters['swatches/getPaletteDataBySwatch'](swatchDefault);
          if (paletteId) {
            const palette = this.$store.state.swatches.palettes.find(item => item.tab_id === paletteId);
            if (palette && palette.palette_only) {
              activeTab = paletteId;
            }
          }
        }
        //Auto Select Tab and Swatch
        if (this.configuration.enableAutoSelect && !isAddYourOwn) {
          if (lastUgcSwatchGroup && !selectedSwatch) {
            // if lastUgcSwatchGroup
            if (lastComponentSwatchApplied === previousComponent && !this.isHideTab(lastComponentSelectedTab)) {
              const { group: lastGroupSelected, subgroup: lastSubGroupSelected } = this.selectedSwatches[previousComponent];
              if (this.containsSubGroup(lastGroupSelected, lastSubGroupSelected, this.activeComponent) && !this.isHideTab(lastComponentSelectedTab)) {
                // activeComponent contains subgroup
                activeTab = lastComponentSelectedTab;
              }
              else {
                // activeComponent does not contain subgroup
                if (!this.isHideTab(this.selectedTab(swatchDefault))) {
                  activeTab = this.selectedTab(swatchDefault);
                }
              }
            }
            else {
              // previousComponent was not component with selection
              if (!this.isHideTab(this.selectedTab(swatchDefault))) {
                activeTab = this.selectedTab(swatchDefault);
              }
            }
          }
          else {
            // if not lastUgcSwatchGroup
            if (!selectedSwatch && lastComponentSelectedTab && !this.isHideTab(lastComponentSelectedTab)) {
              if (previousComponent === lastComponentSwatchApplied) {
                //select the previous component tab with selected swatch
                const swatchesListByComponent = this.$store.state.swatches.swatchesListByComponent[this.activeComponent];
                const lastSwatchId = this.selectedSwatches[previousComponent].swatchId;
                if (this.recipe_v2.components[this.activeComponent] && this.recipe_v2.components[this.activeComponent].hasOwnProperty("ugc") &&
                  this.defaultRecipe.components[this.activeComponent] &&
                  this.recipe_v2.components[this.activeComponent].swatch_id == this.defaultRecipe.components[this.activeComponent].swatch_id) {
                    activeTab = "add-your-own";
                } else if (swatchesListByComponent && swatchesListByComponent.includes(lastSwatchId) && !this.isApparelEnabled) {
                  //swatch id matches
                  activeTab = lastComponentSelectedTab;
                }
                else {
                  //no swatch id matches, show default tab
                  if (!this.isHideTab(this.selectedTab(swatchDefault))) {
                    activeTab = this.selectedTab(swatchDefault);
                  }
                }
              }
              else {
                // select previous component tab with no selected swatch
                const lastComponentTab = this.$store.state.swatches.selectedTabs[previousComponent];
                if (this.recipe_v2.components[this.activeComponent].hasOwnProperty("ugc") &&
                  this.defaultRecipe.components[this.activeComponent] &&
                  this.recipe_v2.components[this.activeComponent].swatch_id == this.defaultRecipe.components[this.activeComponent].swatch_id) {
                    activeTab = "add-your-own";
                } else if (!this.isHideTab(lastComponentTab)) {
                  activeTab = lastComponentTab;
                }
              }
            }
          }
        }

        // check if pattern tab is available for Apparel, if not, show solids
        if ((this.isApparel && activeTab === 'patterns' && !this.apparelGdmParams?.pattern_enable) ||
          (this.isApparel && activeTab === 'add-your-own' && this.disableUGCTab)) {
          activeTab = this.selectedTab(swatchDefault) || "solids";
        }

        // asssign tab for apparel components that do have a default swatch
        if (this.isApparel
          && (!activeTab || this.activeComponent !== activeTab
          && this.componentsWithGraphicsSupport.includes(this.activeComponent)
        )) {
          activeTab = this.activeComponent;
        }

        /*Select by default palette tab when is set up by palette endpoint*/
        const paletteResult = this.$store.state.swatches.palettes.find(palette => palette.default_tab_name !== null);
        if (paletteResult
            && this.getTabsSwatches
            && this.getTabsSwatches[paletteResult.default_tab_name]
            && this.getTabsSwatches[paletteResult.default_tab_name].total > 0) {
          activeTab = paletteResult.default_tab_name;
        }
      }

      if (this.configuration.enableAtomicSwatchTray) {
        this.$store.commit("swatchTray/SET_ACTIVE_TAB", activeTab);
      }

      this.selectTab(activeTab);
      this.$nextTick(() => {
        this.$eventBus.$emit("changeVisibleGroup", activeTab);
      });
    },
    swatchAndTabExists(component, tab, swatchId) {
      const componentTabs = this.getTabsSwatches;
      let availableComponentTabs = [];
      for (let tab of Object.keys(componentTabs)) {
        if (!this.hideTab(componentTabs[tab])) {
          availableComponentTabs.push(tab)
        }
      }

      if (!availableComponentTabs.includes(this.defaultComponentsTab[component])) {
        return false;
      }

      const tabSubgroups = this.getTabsSwatches?.[tab]?.subgroups ?? {}
      const swatchData = this.availableSwatches.find(swatch => Number(swatch.id) === swatchId);
      for (let subgroup of Object.keys(tabSubgroups)) {
        const swatches = tabSubgroups[subgroup]?.swatches;
        if (swatches) {
          const swatchExists = swatches.find((item) => Number(item.id) === swatchId || item.ugc_swatch_group === swatchData.ugc_swatch_group)
          if (swatchExists) {
            return true;
          }
        }
      }

      return false;
    },
    getTabSelectedbySwatch(swatchId, component) {
      let tabsPalette = [];
      let tabs = [];

      if(this.$recipe.getUGCFeatureType(component))
        return "add-your-own";

      for (let tab of Object.keys(this.getTabsSwatches)) {
        const tabSubgroups = this.getTabsSwatches[tab]?.subgroups;
        if (tabSubgroups) {
          for (let subgroup of Object.keys(tabSubgroups)) {
            const swatches = tabSubgroups[subgroup]?.swatches;
            if (swatches) {
              const swatchExists = swatches.find((item) => Number(item.id) === swatchId )
              if (swatchExists) {
                this.getTabsSwatches[tab]?.palette_tab ? tabsPalette.push(tab) : tabs.push(tab);
              }
            }
          }
        }
      }
      return tabsPalette.length > 0 ? tabsPalette[0] : tabs[0]
    },
    getTabSelectedByComponent(previousComponent, nextComponent) {
      const { components: recipeComponents } = this.recipe_v2;
      const { components: defaultComponents } = this.defaultRecipe;

      if (!recipeComponents || !defaultComponents) {
        return
      }

      let { recipeSwatchId: recipePrevSwatchId, defaultSwatchId: defaultPrevSwatchId } = this.$recipe.getSwatchIdsInRecipes({
        recipeComponents,
        defaultComponents,
        component: previousComponent
      });
      // If the component previousComponent has applied ugc,
      // then the next component allows ugc and the ugc is not from swatch
      if (this.checkForUGCComponent(previousComponent) && !this.isUGCFromSwatch(recipeComponents[nextComponent]?.swatch_id) && recipeComponents[nextComponent]?.swatch_id === defaultPrevSwatchId &&  this.$store.getters['ugc/getUGCEnabledComponents'].includes(nextComponent)) {
        return this.defaultComponentsTab[previousComponent];
      }


      if (!previousComponent.includes("/") && !recipePrevSwatchId) {
        return this.defaultComponentsTab[nextComponent];
      }

      let { recipeSwatchId: recipeNextSwatchId, defaultSwatchId: defaultNextSwatchId } = this.$recipe.getSwatchIdsInRecipes({
        recipeComponents,
        defaultComponents,
        component: nextComponent
      })

      if (!nextComponent.includes("/") && !recipeNextSwatchId) {
        return this.defaultComponentsTab[nextComponent];
      }

      if ((recipePrevSwatchId !== defaultPrevSwatchId || this.existSwatchPreviousTab) && recipeNextSwatchId === defaultNextSwatchId && !this.checkForUGCComponent(nextComponent)) {
        if (this.swatchAndTabExists(nextComponent, this.defaultComponentsTab[previousComponent], Number(recipePrevSwatchId))) {
          this.defaultComponentsTab[nextComponent] = this.pdm.components[previousComponent]?.default_tab;
          this.existSwatchPreviousTab = true;
          return this.defaultComponentsTab[previousComponent]
        } else {
          this.existSwatchPreviousTab = false;
          return this.defaultComponentsTab[nextComponent];
        }
      }
      else {
        if (recipePrevSwatchId == defaultPrevSwatchId && recipeNextSwatchId === defaultNextSwatchId) {
          this.defaultComponentsTab[nextComponent] = this.defaultComponentsTab[nextComponent];
        } else {
          const tabBySwatch = this.getTabSelectedbySwatch(Number(recipeNextSwatchId), nextComponent);
          this.defaultComponentsTab[nextComponent] = tabBySwatch || this.defaultComponentsTab[nextComponent];
        }
        this.existSwatchPreviousTab = false;
        return this.defaultComponentsTab[nextComponent];
      }
    },
    /**
     * @param tab the tab object with name and other attributes
     * @param setRotate this parameter is forwarded to the select-component event
     * @param trackChangeTabEvent track a click event in the tab
     */
     changeTab(tab, setRotate = true, trackChangeTabEvent = true) {

      const tabNameDL = (tab.name === 'personalization')  ? 'embroidery' : tab.name;
      if (this.$store.getters['utils/useEcomDataLayerFormat'] && trackChangeTabEvent) {
        this.$customizerDataLayer.logAnalyticsEvent({
          type: this.$customizerDataLayer.types.customizerSubMenu,
          eventLabel: "Select: " + tabNameDL
        });
      } else if (trackChangeTabEvent) {
        dataLayer.push({
          'event':'trackEvent',
          'eventCategory':'customs',
          'eventAction': 'sub-menu',
          'eventLabel':`select: ${tabNameDL}`
        });
      }

      if (!this.configuration.enableCollapsingSwatches) {
        if (this.disabledTab(tab)) return false;
      }

      if (tab.title_only && tab.name !== "image-gallery" && tab.name !== "add-your-own" && tab.name !== "yourcolors") {
        if (tab.name ==='personalization' && this.enablePersonalization) {
          if (this.configuration.modals?.embroidery) {
            this.$modal.show('embroideryModal');
          } else {
            this.$modal.show('newEmbroideryModal');
          }
        } else {
          this.$modal.show(tab.name);
        }
        return false;
      } else {
        if (this.configuration.enableAtomicSwatchTray) this.$store.commit("swatchTray/SET_ACTIVE_TAB", tab.name);
      }

      let componentSelected = this.activeComponent;

       if (this.isApparel) {
        if (tab.name !=='add-your-own' && tab.name !=='tee-color' && tab.name !=='yourcolors' && tab.name !==DEFAULT_TAB && tab.name !== 'patterns' && typeof tab.name !== undefined) {
          if (this.activeComponent !== tab.name) {
            componentSelected = tab.name;
            // setRotate is true when the tab is clicked and false when the 3D model is clicked
            this.$eventBus.$emit("select-component", tab.name, null, setRotate, "", true, false, false);
          }
        }
      }
      this.selectTab(tab.name, componentSelected);
      this.$eventBus.$emit("changeVisibleGroup", tab.name);
    },
    selectPreviousTab() {
      if (this.previousActiveTab && this.previousSelectedComponent) {
        const previous = this.getGroupTabs[this.previousActiveTab];
        this.changeTab(previous);
      }
    },
    selectTab(tab, componentSelected) {
      if (this.configuration.enableNewHistoryTabLogic && componentSelected) {
        this.defaultComponentsTab[componentSelected] = tab;
      }
      if (!this.isApparel) {
        this.active_tab = tab;
        this.$store.commit("swatches/SET_TABS_SELECTED", { component: this.activeComponent, tab });
        return;
      }
      this.previousActiveTab = this.active_tab;
      this.previousSelectedComponent = componentSelected;
      this.active_tab = tab;
      if (componentSelected) {
        const componentObj =  this.componentsWithGraphicsSupport.includes(tab) || tab === 'tee-color'
          ? { component: tab, tab }
          : { component: componentSelected, tab }
        this.$store.commit("swatches/SET_TABS_SELECTED", componentObj);

        if (this.isApparel && this.componentsWithGraphicsSupport.includes(tab)) {
          const temp = {};
          if(String(componentSelected).search('/') !== -1){
            const component =  String(componentSelected).split('/');
            temp.activeComponent = component[0];
            temp.activeSubComponent = component[1];
          } else {
            temp.activeComponent = componentSelected;
            temp.activeSubComponent = '';
          }
          this.$store.dispatch("standardNavigation/UPDATE_STANDARD_NAVIGATION", temp);
        }
      }
    },
    renderGroups(groups) {
      const promises = [];
      this.primaryTabs = groups;
      const tabs = {};
      this.primaryTabs.forEach(tab => {
        if (tab.child_lists) {
          promises.push(
            this.$store
              .dispatch("swatches/GET_SUBGROUP_TABS", tab.child_lists)
              .then(response => {
                this.saveSubgroupData(tab.name, response);
              })
          );
        } else if (tab.name === "solids") {
          if (!this.subgroups[tab.name]) this.subgroups[tab.name] = {};
          this.subgroups[tab.name][tab.name] = {
            ...tab
          };
        }
        tabs[tab.name] = tab;
      });
      if (!this.enablePersonalization && tabs["personalization"]) {
        delete tabs["personalization"];
      }
      this.$store.commit("swatches/SET_GROUP_TABS", tabs);

      Promise.all(promises).then(() => {
        this.$store.commit("swatches/SET_SUBGROUPS", this.subgroups);
        this.$eventBus.$emit("tabsDataRendered");
      });
    },
    saveSubgroupData(parentTabName, subgroups) {
      if (!this.subgroups[parentTabName]) this.subgroups[parentTabName] = {};
      subgroups.forEach(group => {
        if (group.palette_id) {
          this.subgroups[parentTabName][group.palette_id] = {
            order: this.order++,
            ...group
          };
        } else {
          this.subgroups[parentTabName][group.name] = {
            order: this.order++,
            ...group
          };
        }
      });
    },
    disabledTab(tab) {
      if (this.configuration.enableCollapsingSwatches) return false;
      return (
        (tab.name === "add-your-own" && (!this.isUGC || this.disableUGCTab)) ||
        (tab.name === "image-gallery" && !this.isImageLibrary) ||
        (!tab.feature_tab && tab.total == 0) ||
        (tab.name === "personalization" && (!this.isPersonalization || !this.personalizationAllowed))
      );
    },
    hideTab(tab) {
      let hidePerBlockedTab = false;
      //Apparel logic
      /** Validate your colors exclusivity when exist the swatches into the swatchesRelation and it is not the active component */
      if (this.isApparel && tab.name === "yourcolors" && Object.keys(this.selectedSwatches).some(selected =>
        !!Object.keys(this.swatchesRelation).find(data => data == this.selectedSwatches[selected].swatchId) &&
        !this.swatchesRelation[this.selectedSwatches[selected].swatchId]?.pick_own_color && this.activeComponent.search(selected) !== -1
       )) return true
      if (!this.isApparel && tab.name === "yourcolors" || this.isApparel && tab.name === "yourcolors" && !this.apparelGdmParams?.pyoc_enable) return true;
      if (this.isApparel && tab.name === "add-your-own" && !this.activeSubComponent) return true;
      if (this.isApparel && !this.disableUGCTab && this.isApparelUGC && tab.name === "add-your-own" && this.activeSubComponent) return false;
      if (this.isApparel && (tab.name === 'patterns' || tab.name === 'strangerthings') && !this.apparelGdmParams?.pattern_enable) return true;

      // If there are ugc_lock AND palette_lock OR unique_swatch, show ONLY ugc_lock palette tab
      // (without personalization since palette_lock or unique_swatch does not allow it)
      if (this.ugcBlockedTab && this.uniqueSwatchesAndPaletteBlockedTabs.length) {
        hidePerBlockedTab = !!this.ugcBlockedTab && tab.name !== this.ugcBlockedTab;
      // If there is ONLY ugc_lock show ONLY ugc_lock palette tab AND personalization
      } else if (this.ugcBlockedTab) {
        hidePerBlockedTab = !!this.ugcBlockedTab && tab.name !== this.ugcBlockedTab && tab.name !== 'personalization';
      // If there are ONLY palette_lock or unique_swatch and are part of active component show ONLY allowed palette tabs
      } else if (this.uniqueSwatchesAndPaletteBlockedTabs.length) {
        hidePerBlockedTab = !!this.defaultUniqueSwatchesPaletteBlockedPerComponent
          ? !this.uniqueSwatchesAndPaletteBlockedTabs.filter(lockedTab => lockedTab === tab.name).length
          : tab.name === "add-your-own" || tab.name === "personalization" || tab.name === "image-gallery";
      // If there are ONLY palette_lock or unique_swatch and are NOT part of active component show ALL tabs
      // (without personalization and add your own)
      } else if (this.$store.getters['swatches/lockedPalettes'].length || this.$store.getters['swatches/uniqueSwatches'].length) {
        hidePerBlockedTab = tab.name === "add-your-own" || tab.name === "personalization" || tab.name === "image-gallery";
      }

      if (this.configuration.enableCollapsingSwatches) {
        return hidePerBlockedTab ||
          (tab.name === "add-your-own" && (!this.isUGC || this.disableUGCTab)) ||
          (tab.name === "image-gallery" && !this.isImageLibrary) ||
          (!this.getAvailableTabs.includes(tab.name) && !tab.title_only) ||
          (tab.name === "add-your-own" && (!this.hasModelUgc || !!Object.keys(this.ugcBlockedPalettes).length || this.disableUGCTab)) ||
          (tab.name === "personalization" && (this.$store.getters["personalization/getPrimaryComponentName"] === "" || !this.personalizationAllowed)) ||
          (!tab.feature_tab && tab.total == 0)
          ? true
          : false;
      } else {
        return hidePerBlockedTab ||
          (!tab.feature_tab && !this.getAvailableTabs.includes(tab.name) && !tab.title_only) ||
          (tab.name === "add-your-own" && (!this.hasModelUgc || !!Object.keys(this.ugcBlockedPalettes).length)) ||
          (tab.name === "image-gallery" && (!this.isImageLibrary || !!Object.keys(this.ugcBlockedPalettes).length)) ||
          (tab.name === "personalization" && this.$store.getters["personalization/getPrimaryComponentName"] === "") ||
          (!tab.feature_tab && tab.total == 0)
          ? true
          : false;
      }
    },
    swatchGroupName(swatch) {
      return this.$store.getters["swatches/returnSwatchGroupName"]({ swatch });
    },
    paletteGroupName(swatchId) {
      return this.$store.getters["swatches/getPaletteDataBySwatch"](swatchId);
    },
    getTabsAvailable() {
      let tabsAvailable = [];
      this.availableSwatches.forEach(swatch => {
        let groupName = this.swatchGroupName(swatch);
        tabsAvailable = this.addAvailableTabs(tabsAvailable, groupName);
      });
      this.$store.commit("swatches/SET_AVAILABLE_TABS", tabsAvailable);
    },
    addAvailableTabs(tabs, group) {
      if (!tabs.includes(group)) {
        tabs.push(group);
      }
      return tabs;
    },
    isUGCFromSwatch(swatchId) {
      return this.$store.getters["swatches/isUGCFromSwatch"]({ swatchId });
    },
    getSwatchObj(swatchId) {
      return this.$store.getters["swatches/returnSwatchObj"]({ swatchId });
    },
    // TODO
    checkForUGCComponent(componentName) {
      return this.$store.getters["recipe/checkForUGCComponent"]({ componentName });
    },
    swatchesByComponent(componentName) {
      return this.$store.state.swatches.swatchesByComponent[componentName];
    },
    containsSubGroup(groupName, subgroupName, componentName) {
      let swatchesByComp = this.swatchesByComponent(componentName)[groupName];
      return Object.keys(swatchesByComp).includes(subgroupName);
    },
    checkForAddYourOwn(previousComponent, selectedSwatch, isPrecreated) {
      let addYourOwn = false;
      if (previousComponent.length > 0 && this.configuration.enableAutoSelect && !isPrecreated && !selectedSwatch) {
        const previousComponentUGCEnabled = this.$store.getters['ugc/getUGCEnabledComponents'].includes(previousComponent);
        const isComponentEnabled = this.$store.getters['ugc/getUGCEnabledComponents'].includes(this.activeComponent);
        const isUgcApplied = this.$store.getters['ugc/getComponentsWithUGCApplied'].includes(this.activeComponent);
        const hasUgcOrPatternOrCustomCheckerboard = this.$recipe.checkUGCByType({ includePatternMaker: true, includeCustomCheckerboard: true, customUGC: true });
        if (isComponentEnabled && previousComponentUGCEnabled && hasUgcOrPatternOrCustomCheckerboard || isUgcApplied && isComponentEnabled || isComponentEnabled && hasUgcOrPatternOrCustomCheckerboard) {
          addYourOwn = true;
        }
      }
      return addYourOwn;
    },
    checkforUGCSwatchGroup(lastComponentSwatchApplied) {
      const lastComponentSelectedTab = this.$store.state.swatches.selectedTabs[this.lastComponentSwatchApplied];
      const previousSwatch = this.selectedSwatches[lastComponentSwatchApplied];
      if (previousSwatch) {
        const ugcSwatchGroup = previousSwatch.ugcswatchgroup || false;
        return ugcSwatchGroup;
      }
      return;
    },
    selectedTab(swatchId) {
      let swatchFind = this.getSwatchObj(swatchId);
      if (swatchFind) {
        return this.swatchGroupName(swatchFind);
      }
    },
    isHideTab(groupName) {
      if (!this.getTabsSwatches || !this.getTabsSwatches[groupName] || !this.getTabsSwatches[groupName].total) {
        return true;
      }

      return this.getTabsSwatches[groupName].total <= 0;
    },
    componentSwatchIsDefault() {
      if (!this.selectedSwatches[this.activeComponent])
        return true;

      let swatchId = this.selectedSwatches[this.activeComponent].swatchId;
      return swatchId < 0;
    },
    setHistoryTab() {
      if (this.selectedSwatches[this.activeComponent]) {
        this.$store.commit(
          "swatches/SET_HISTORY_SELECTED_TABS",
          this.activeComponent
        );
      }
    },
    initGroups() {
      const promises = [];

      if (this.isApparel) {
        const { components } = this.pdm;

        Object.keys(components).forEach((component) => {
          if (!components[component].visible) {
            promises.push(this.$store.dispatch(
              'swatches/GET_AVAILABLE_SWATCHES_BY_COMPONENT',
              { component, isApparelEnabled: this.isApparel },
            ));
          }
        });
      } else {
        promises.push(this.$store.dispatch(
          'swatches/GET_AVAILABLE_SWATCHES_BY_COMPONENT',
          { isApparelEnabled: this.isApparel },
        ));
      }

      Promise.all(promises)
        .then(() => this.$store.dispatch('swatches/GET_GROUP_TABS'))
        .then((response) => {
          this.renderGroups(response);
          this.getTabsAvailable();
        });
    },
    blockUGCTab(block) {
      this.disableUGCTab = block;
    },
    disablePersonalizationTab() {
      this.personalizationAllowed = true;
      const { components } = this.recipe_v2;
      for (let item in components) {
        let swatchId = components[item].swatch_id;

        const swatchObject = this.$store.getters['swatches/returnSwatchObj']({ swatchId: swatchId });
        if (swatchObject && swatchObject.personalization) {
          this.personalizationAllowed = false;
          return;
        }

        let relation = this.swatchesRelation[swatchId];
        if (relation && !relation.personalization_allowed) {
          this.personalizationAllowed = relation.personalization_allowed;
          return;
        }

        if (this.isToolAvailablebyFeature({ tool: "embroidery", componentObj : components[item]})) {
          this.personalizationAllowed = false;
          return;
        }

      }
    },
    blockFeaturesByRecipeID(response) {
      this.personalizationAllowed = response.personalization_allowed && this.getEmbroideryActiveByRecipe();
    },
    hasUGCTooltip(name) {
      return this.$store.state.utils.pdm.ugcPriceToolTip && name === 'add-your-own' ? true : false;
    },
    /**
     * Validate if is available embroidery in pregreated recipe per feature e.g. crayola as feature
     */
    getEmbroideryActiveByRecipe() {
      const ugcComponents = this.$recipe.getUGCComponents();
      if(ugcComponents) {
        for (let component of ugcComponents) {
          if ( this.isToolAvailablebyFeature({ tool: "embroidery", componentObj : this.recipe_v2.components[component]}) ) {
            return false;
          }
          };
      }
      return true;
    },
    /**
     * Validate if the feature is available per tool e.g. crayola as feature
     */
    isToolAvailablebyFeature({tool, componentObj}) {
      return componentObj.group === "ugc" && !!this.$store.state.utils.disableToolByFeatures[tool].find(feature => feature === componentObj.subgroup);
    },
    resetPropertiesInit() {
      this.propertiesInit = [];
      this.initGroup = 0;
    }
  }
}
